import React from "react";
import axios from "axios";
import { Cpu, Printer, ScanLine, Tablet, Package, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TYPE_INFO = {
  thermal_printer: { icon: Printer, label: "Thermal-printer" },
  barcode_scanner: { icon: ScanLine, label: "QR/Barcode-scanner" },
  labels: { icon: Package, label: "Labels & ruller" },
  tablet: { icon: Tablet, label: "Tablet / Android-enhed" },
  stand: { icon: Cpu, label: "Stander / display" },
  signage: { icon: Package, label: "Skiltning / branding" },
};

export default function EquipmentTab({ token }) {
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    axios.get(`${API}/pakkeshop/equipment`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setItems(data.equipment || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="text-[#475569] text-center py-10" data-testid="equipment-loading">Indlæser udstyr...</div>;

  return (
    <div className="space-y-4" data-testid="equipment-panel">
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
        <AlertCircle size={18} className="text-amber-600 shrink-0 mt-0.5" />
        <div className="text-sm text-amber-900 leading-relaxed">
          <strong>Vigtigt om udstyret:</strong> Alt udstyr nedenfor tilhører <strong>EMA Kurer ApS</strong> og må kun bruges
          til EMA Pickup Point — ikke andre fragtfirmaer eller private formål. Ved skade, tab eller manglende returnering ved
          ophør kan EMA opkræve erstatning svarende til udstyrets værdi.
        </div>
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-[#E2E8F0] rounded-xl p-10 text-center text-[#475569]" data-testid="equipment-empty">
          <Cpu size={32} className="mx-auto opacity-50 mb-3" />
          Du har endnu ikke modtaget udstyr fra EMA. Kontakt partner@emakurer.dk hvis du mangler.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="equipment-list">
          {items.map((eq) => {
            const Info = TYPE_INFO[eq.type] || { icon: Cpu, label: eq.type };
            const Icon = Info.icon;
            return (
              <div key={eq.id} className="bg-white border border-[#E2E8F0] rounded-xl p-5 flex items-start gap-4" data-testid={`equipment-${eq.id}`}>
                <div className="bg-[#0A1128] text-white p-3 rounded-lg shrink-0">
                  <Icon size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-display font-bold text-[#0A1128]">{Info.label}</div>
                  {eq.model_name && <div className="text-sm text-[#0A1128] mt-1">{eq.model_name}</div>}
                  {eq.serial_number && <div className="text-xs text-[#475569] font-mono mt-0.5">SN: {eq.serial_number}</div>}
                  <div className="text-xs text-[#475569] mt-1">
                    Tildelt {(eq.assigned_at || "").slice(0, 10)} · Værdi {eq.value_dkk?.toFixed?.(0) || 0} kr
                  </div>
                  {eq.damage_charge_dkk > 0 && (
                    <div className="mt-2 text-xs bg-red-50 text-red-800 border border-red-200 px-2 py-1 rounded">
                      Erstatningskrav: {eq.damage_charge_dkk} kr
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
